"use client";

import { useEffect } from "react";
import posthog from "posthog-js";
import { captureFirstTouch } from "@/lib/tracking/firstTouch";

// Captures acquisition first-touch (UTM + click ids) on the first landing and
// mirrors it onto the PostHog person via register_once — so paid-campaign
// attribution (e.g. TikTok ads) survives the visit → signup → subscribe gap and
// the click id (ttclid), which PostHog's auto-UTM capture does NOT include, is
// queryable in PostHog. No-op after the first capture. Mounted once at the app
// root (app/layout.tsx).
export function FirstTouchCapture() {
  useEffect(() => {
    const ft = captureFirstTouch();
    if (!ft) return;
    try {
      // posthog is only initialised in production (instrumentation-client.ts);
      // __loaded guards against a pre-init/dev no-op.
      if (posthog.__loaded) {
        posthog.register_once({
          initial_utm_source: ft.utm_source,
          initial_utm_medium: ft.utm_medium,
          initial_utm_campaign: ft.utm_campaign,
          initial_utm_content: ft.utm_content,
          initial_ttclid: ft.ttclid,
          initial_landing_path: ft.landing_path,
        });
      }
    } catch {
      // analytics must never throw into product code
    }
  }, []);
  return null;
}
